function t(t) {
  var e = t.clientWidth,
    _getComputedStyle = getComputedStyle(t),
    a = _getComputedStyle.paddingLeft,
    d = _getComputedStyle.paddingRight;
  return e - parseFloat(a) - parseFloat(d);
}
export { t as default };